import {Component} from "@angular/core";
import {AdminResultCaseService} from "../case.service";
import {ViewManagerService} from "../../../services/view-manager.service";

@Component({
  selector: "admin-results-cases",
  templateUrl: "./cases.component.html",
  styleUrls: ["./cases.component.css"]
})
export class AdminResultsCasesComponent {

  constructor(
    private caseService: AdminResultCaseService,
    private viewManager: ViewManagerService
  ) {
  }


}
